
import { createContext } from "react";
import { AppUser } from "@/types/supabase";

export type AppSession = {
  user: AppUser;
};

export type AuthContextType = {
  user: AppUser | null;
  session: AppSession | null;
  loading: boolean;
  isAdmin: boolean;
  isAdminLoading: boolean;
  refreshSession: () => Promise<void>;
  signIn: (email: string, password: string) => Promise<{ error?: string, success?: boolean }>;
  signUp: (email: string, password: string, firstName: string, lastName: string) => Promise<{ user?: AppUser | null; requiresEmailConfirmation?: boolean; success?: boolean } | undefined>;
  signOut: () => Promise<void>;
  signInWithGoogle: () => Promise<void>;
  updateProfile: (data: { 
    first_name?: string; 
    last_name?: string; 
    email?: string | null;
    avatar_url?: string;
    whatsapp_number?: string;
  }) => Promise<void>;
  toggleMfa: (enable: boolean) => Promise<void>;
  updatePassword: (newPassword: string) => Promise<{ success: boolean, error?: string }>;
  resetPassword: (email: string, redirectTo: string) => Promise<{ success: boolean, error?: string }>;
  deleteAccount: () => Promise<void>;
};

// Create the context with undefined as default value
const AuthContext = createContext<AuthContextType | undefined>(undefined);

export default AuthContext;
